export class OperatorPriceChangeFilterEntity {
  branchId?: number
  fromDate?: string
  toDate?: string
  page?: number
  limit?: number
}
